import { useState } from "react";
import { EntityManager } from "@/components/EntityManager";
import { ClientInvoiceUploader } from "@/components/ClientInvoiceUploader";
import { PartyAging } from "@/components/PartyAging";
import { ENTITY_CONFIG } from "@/lib/entities";

export default function Receivables() {
  const [reloadKey, setReloadKey] = useState(0);
  return (
    <div className="space-y-6">
      <ClientInvoiceUploader onPosted={() => setReloadKey((k) => k + 1)} />
      <PartyAging key={`aging-${reloadKey}`} />
      <EntityManager key={reloadKey} config={ENTITY_CONFIG.receivables} />
    </div>
  );
}
